import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Proxima Nova';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/ProximaNova.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Proxima Nova';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/ProximaNovaBold.woff2') format('woff2');
      }
      `}
  />
);

export default Fonts;
